import styled from "styled-components";

const StyledEmoji = styled.span`
  cursor: pointer;
`;

export default StyledEmoji;
